























import Component, { mixins } from "vue-class-component";
import Main from "@/components/app/Main.vue";
import OfficeSelect from "@/components/app/OfficeSelect.vue";
import InlineFrame from "@/components/app/InlineFrame.vue";
import HonobonoInlineFrame from "@/components/app/HonobonoInlineFrame.vue";
import MockToken from "@/components/app/MockToken.vue";
import DirectAccessError from "@/components/app/DirectAccessError.vue";
import AxiosMixin from "@/mixins/axiosMixin";
import Cookies from "js-cookie";

window.axios = require("axios");

window.base_url = process.env.VUE_APP_BACKEND_URL;
if (!window.base_url) {
  window.base_url = "http://localhost:9061";
}

window.mode = process.env.VUE_APP_MODE;
if (!window.mode) {
  window.mode = "development";
}

@Component({
  components: {
    Main,
    OfficeSelect,
    InlineFrame,
    MockToken,
    DirectAccessError,
    HonobonoInlineFrame
  }
})
export default class App extends mixins(AxiosMixin) {
  private isSelect = false; //事業所選択済
  private isToken = false; //トークン認証済
  private isAgree = false; //テスト版同意済
  private isHonobono = false; //ほのぼの有
  private mode = window.mode;

  created() {
    if (location.href.indexOf("?onetime=") != -1) {
      const st = location.href.indexOf("?onetime=");
      const en = location.href.length;
      this.onetime(location.href.substring(st + 9, en));
    } else {
      const token = Cookies.get("token");
      const refToken = Cookies.get("reftoken");
      if (token && refToken) {
        window.token = token;
        window.reftoken = refToken;
        this.token();
        const isAgree = Cookies.get("isAgree");
        if (isAgree) {
          this.attention();
        }
        const user_name = Cookies.get("user_name");
        if (user_name) {
          window.user_name = user_name;
        }
        const office_name = Cookies.get("office_name");
        if (office_name) {
          window.office_name = office_name;
          this.select();
        }
        const isHonobono = Cookies.get("isHonobono");
        if (isHonobono) {
          this.isHonobono = true;
        }
        const button_ctrl = Cookies.get("button_ctrl");
        if (button_ctrl) {
          window.button_ctrl = (button_ctrl == "1");
        }
      }
    }
  }

  //ワンタイムトークンで認証
  private onetime(token: string) {
    this.postJsonCheck(
      window.base_url + "/auth/fromonetime",
      { one_time_token: token },
      res => {
        window.token = res.data.token;
        Cookies.set("token", window.token);
        window.reftoken = res.data.ref_token;
        Cookies.set("reftoken", window.reftoken);
        Cookies.set("isAgree", "");
        window.user_name = res.data.user_name;
        Cookies.set("user_name", window.user_name);
        this.token();
        window.office_name = res.data.office_name;
        Cookies.set("office_name", window.office_name);
        if (window.office_name) {
          this.select();
        }
        if (res.data.is_honobono) {
          this.isHonobono = true;
          Cookies.set("isHonobono", res.data.is_honobono);
        } else {
          this.isHonobono = false;
          Cookies.set("isHonobono", "");
        }
        window.button_ctrl = (res.data.receipt_agency_ibowrec_button == "1");
        Cookies.set("button_ctrl", res.data.receipt_agency_ibowrec_button);
        this.$router.replace({ path: "/" });
      }
    );
  }

  private token() {
    this.isToken = true;
  }

  private attention() {
    this.isAgree = true;
  }

  private select() {
    this.isSelect = true;
  }

  private selectOff() {
    if (this.$router.currentRoute.path == "/") {
      this.isSelect = false;
    }
    this.$router.push({ path: "/" }, () => {
      this.isSelect = false;
    });
  }
}
